module.exports = __webpack_public_path__ + "assets/images/EUR.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR.png
// module id = 1355
// module chunks = 1